export class AureliaApplicationSettings {
    Authority: string;
    ApplicationHost: string;
    KioskTypes: Array<string>;
}